import { CountriesStates }     from './countries.states.ajs';
import { CountriesStatesCtrl } from './countries.countries-states.ajs';
import { NewCountryTypeCtrl }  from './countries.new-country-type';
import { NewStateTypeCtrl }    from './countries.new-state-type';

angular.module('workshop.countries', [])
.controller('CountriesStatesCtrl', CountriesStatesCtrl)
.controller('newCountryTypeCtrl', NewCountryTypeCtrl)
.controller('newStateTypeCtrl', NewStateTypeCtrl)
.config(CountriesStates);